import { render, staticRenderFns } from "./CommentsHome.vue?vue&type=template&id=041234c8&"
import script from "./CommentsHome.vue?vue&type=script&lang=js&"
export * from "./CommentsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports